import React, { createContext, useContext, useState } from 'react';

// Create the context
const AIChatContext = createContext();

// Custom hook to use the AI Chat context
export const useAIChat = () => {
  const context = useContext(AIChatContext);
  if (!context) {
    throw new Error('useAIChat must be used within an AIChatProvider');
  }
  return context;
};

// Provider component
export const AIChatProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openChat = () => setIsOpen(true);
  const closeChat = () => setIsOpen(false);
  const toggleChat = () => setIsOpen(prev => !prev);

  const value = {
    isOpen,
    openChat,
    closeChat,
    toggleChat
  };

  return (
    <AIChatContext.Provider value={value}>
      {children}
    </AIChatContext.Provider>
  );
};

export default AIChatContext;